// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__OtrWr","top":"styles_top__1-70l"};